export const authRolesTypes = {
    read: "[AuthRoles] read",
    toHotel: "[AuthRoles] toHotel",
    toOriginal: "[AuthRoles] toOriginal",
    clean: "[AuthRoles] clean",
};
